import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AnalysisPizzaTracker } from '@/features/analysis/components/AnalysisPizzaTracker';
import { AnalysisMinimizedIndicator } from '@/features/analysis/components/AnalysisMinimizedIndicator';
import { useAnalysisProgress } from '@/features/analysis/hooks/useAnalysisProgress';

export default function AnalysisProgressPage() {
  const [searchParams] = useSearchParams();
  const runId = searchParams.get('runId');
  const navigate = useNavigate();
  const [isMinimized, setIsMinimized] = useState(false);

  const { progress, stage } = useAnalysisProgress(runId || '');

  if (!runId) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Invalid Analysis</h1>
          <p className="text-muted-foreground">No run ID provided.</p>
        </div>
      </div>
    );
  }

  const handleComplete = () => {
    // Navigate to authoritative Analysis page
    navigate(`/analysis/${runId}`);
  };

  const handleMinimizeToggle = () => {
    setIsMinimized(!isMinimized);
  };

  return (
    <div className="min-h-screen bg-background p-4">
      {isMinimized ? (
        <AnalysisMinimizedIndicator
          progress={progress}
          onClick={handleMinimizeToggle}
        />
      ) : (
        <AnalysisPizzaTracker
          swingRunId={runId}
          minimized={isMinimized}
          onMinimizeToggle={handleMinimizeToggle}
          onComplete={handleComplete}
        />
      )}
    </div>
  );
}

